import { createSlice, current } from '@reduxjs/toolkit';
import {
	getRealEstateRegistryList,
	getRealEstateRegistry,
	addNewRealEstateRegistry,
	updateRealEstateRegistry,
	deleteRealEstateRegistry,
	checkRealEstateRegistryExists,
} from './thunk';

export const initialState = {
	itemRealEstateRegistryList: [],
	itemRealEstateRegistry: null,
	isRealEstateRegistryLoading: false,
	isRealEstateRegistrySuccess: false,
	dataRealEstateRegistry: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const RealEstateRegistrySlice = createSlice({
	name: 'RealEstateRegistry',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getRealEstateRegistryList.pending, state => {
			state.isLoadingList = true;
			state.isRealEstateRegistrySuccess = false;
		});

		builder.addCase(getRealEstateRegistryList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemRealEstateRegistryList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isRealEstateRegistrySuccess = true;
		});

		builder.addCase(getRealEstateRegistryList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isRealEstateRegistrySuccess = false;
		});

		builder.addCase(getRealEstateRegistry.pending, state => {
			state.isRealEstateRegistryLoading = true;
			state.isRealEstateRegistrySuccess = false;
		});

		builder.addCase(getRealEstateRegistry.fulfilled, (state, action) => {
			state.itemRealEstateRegistry = action.payload;
			state.isRealEstateRegistryLoading = false;
			state.isRealEstateRegistrySuccess = true;
		});

		builder.addCase(getRealEstateRegistry.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isRealEstateRegistryLoading = false;
			state.isRealEstateRegistrySuccess = false;
		});

		builder.addCase(addNewRealEstateRegistry.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewRealEstateRegistry.fulfilled, (state, action) => {
			state.itemRealEstateRegistryList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewRealEstateRegistry.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateRealEstateRegistry.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateRealEstateRegistry.fulfilled, (state, action) => {
			state.itemRealEstateRegistryList = state.itemRealEstateRegistryList.map(
				realEstateRegistryList =>
					realEstateRegistryList._id.toString() === action.payload._id.toString()
						? { ...realEstateRegistryList, ...action.payload }
						: realEstateRegistryList
			);
			state.statementList = state.statementList.map(realEstateRegistryList =>
				realEstateRegistryList._id.toString() === action.payload._id.toString()
					? { ...realEstateRegistryList, ...action.payload }
					: realEstateRegistryList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateRealEstateRegistry.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteRealEstateRegistry.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteRealEstateRegistry.fulfilled, (state, action) => {
			state.itemRealEstateRegistryList = current(
				state.itemRealEstateRegistryList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteRealEstateRegistry.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkRealEstateRegistryExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkRealEstateRegistryExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkRealEstateRegistryExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = RealEstateRegistrySlice.actions;

export default RealEstateRegistrySlice.reducer;
